const baseURL = "https://pizza-server-51rl.onrender.com/api";
//const baseURL = "https://pizzzaaaa-server.herokuapp.com/api";

export default baseURL;
